import { useCallback, type FC } from 'react';
import { useAllMerchants } from '../../hooks';
import { useMerchantStore } from '../../store';

export const MerchantSelector: FC = () => {
  const merchantId = useMerchantStore((state) => state.merchantId);
  const changeMerchantId = useMerchantStore((state) => state.changeMerchantId);
  const merchants = useAllMerchants();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      changeMerchantId(Number(event.target.value));
    },
    [changeMerchantId],
  );

  if (merchants.length === 0) {
    return null;
  }

  return (
    <select className="input  px-2 py-1 rounded-lg text-xs appearance-none" onChange={handleChange} value={merchantId}>
      {merchants.map((merchant) => (
        <option key={merchant.id} value={merchant.id}>
          {merchant.name}
        </option>
      ))}
    </select>
  );
};
